export const shiftRevenueReportMessages = {
  vi: {
    'shiftRevenueReport.title': 'Doanh thu theo ca',
    'shiftRevenueReport.filters.branch': 'Chi nhánh',
    'shiftRevenueReport.filters.shift': 'Ca làm việc',
    'shiftRevenueReport.filters.staff': 'Nhân viên',
    'shiftRevenueReport.filters.source': 'Nguồn bán',
    'shiftRevenueReport.filters.all': 'Tất cả',
    'shiftRevenueReport.filters.unassigned': 'Chưa xác định ca',
    'shiftRevenueReport.filters.direct': 'Bán hàng thường',
    'shiftRevenueReport.filters.table': 'Bán hàng theo bàn',
    'shiftRevenueReport.actions.view': 'Xem báo cáo',
    'shiftRevenueReport.actions.export': 'Xuất Excel',
    'shiftRevenueReport.stats.revenue': 'Tổng doanh thu',
    'shiftRevenueReport.stats.invoices': 'Số hóa đơn',
    'shiftRevenueReport.stats.discount': 'Giảm giá',
    'shiftRevenueReport.stats.vat': 'VAT',
    'shiftRevenueReport.stats.paid': 'Đã thu',
    'shiftRevenueReport.stats.debtPaid': 'Thu nợ trong ca',
    'shiftRevenueReport.debtPaid.invoice': 'Hóa đơn',
    'shiftRevenueReport.debtPaid.customer': 'Khách hàng',
    'shiftRevenueReport.debtPaid.receipt': 'Phiếu thu',
    'shiftRevenueReport.debtPaid.amount': 'Đã thu',
    'shiftRevenueReport.stats.debt': 'Công nợ',
    'shiftRevenueReport.stats.formula.revenue':
      'Tổng doanh thu = Tiền đã thu + Công nợ còn lại của các ca',
    'shiftRevenueReport.stats.formula.invoices': 'Số hóa đơn = Số hóa đơn hoàn thành của các ca',
    'shiftRevenueReport.stats.formula.discount': 'Giảm giá = Tổng tiền giảm trên các hóa đơn',
    'shiftRevenueReport.stats.formula.vat': 'VAT = Tổng thuế VAT trên các hóa đơn',
    'shiftRevenueReport.stats.formula.paid':
      'Đã thu = Tiền trả hóa đơn (không tính cọc) + Tiền cọc đơn hàng/bàn + Tiền thu nợ trong ca',
    'shiftRevenueReport.stats.formula.debt':
      'Công nợ = Công nợ phát sinh của các ca - Tiền thu nợ trong ca (không nhỏ hơn 0)',
    'shiftRevenueReport.stats.formulaTitle': 'Công thức tính',
    'shiftRevenueReport.payments': 'Phương thức thanh toán',
    'shiftRevenueReport.payments.cash': 'Tiền mặt',
    'shiftRevenueReport.payments.card': 'Thẻ',
    'shiftRevenueReport.payments.bank_transfer': 'Chuyển khoản',
    'shiftRevenueReport.payments.transfer': 'Chuyển khoản',
    'shiftRevenueReport.payments.other': 'Khác',
    'shiftRevenueReport.sources.direct': 'Bán hàng thường',
    'shiftRevenueReport.sources.table': 'Bán hàng theo bàn',
    'shiftRevenueReport.sources.table_session': 'Bán hàng theo bàn',
    'shiftRevenueReport.customers.walkIn': 'Khách lẻ',
    'shiftRevenueReport.table.date': 'Ngày ca',
    'shiftRevenueReport.table.shift': 'Ca',
    'shiftRevenueReport.table.time': 'Thời gian',
    'shiftRevenueReport.table.staff': 'Nhân viên',
    'shiftRevenueReport.table.invoices': 'Hóa đơn',
    'shiftRevenueReport.table.productQuantity': 'SL sản phẩm',
    'shiftRevenueReport.table.revenue': 'Doanh thu',
    'shiftRevenueReport.table.paid': 'Đã thu',
    'shiftRevenueReport.table.debt': 'Công nợ',
    'shiftRevenueReport.table.invoiceCode': 'Mã hóa đơn',
    'shiftRevenueReport.table.status': 'Trạng thái',
    'shiftRevenueReport.status.completed': 'Hoàn thành',
    'shiftRevenueReport.status.cancelled': 'Đã hủy',
    'shiftRevenueReport.table.completedAt': 'Hoàn thành lúc',
    'shiftRevenueReport.table.source': 'Nguồn',
    'shiftRevenueReport.table.customer': 'Khách hàng',
    'shiftRevenueReport.table.payment': 'Thanh toán',
    'shiftRevenueReport.empty': 'Không có dữ liệu doanh thu',
    'shiftRevenueReport.emptyHint': 'Hãy thử thay đổi khoảng ngày hoặc bộ lọc.',
    'shiftRevenueReport.retry': 'Thử lại',
    'shiftRevenueReport.errors.loadFailed': 'Không thể tải báo cáo doanh thu theo ca.',
    'shiftRevenueReport.products.shiftTitle': 'Tất cả sản phẩm đã bán trong ca',
    'shiftRevenueReport.products.staffTitle': 'Sản phẩm do {name} bán',
    'shiftRevenueReport.products.sku': 'Mã SKU',
    'shiftRevenueReport.products.name': 'Sản phẩm',
    'shiftRevenueReport.products.unit': 'Đơn vị',
    'shiftRevenueReport.products.quantity': 'Số lượng',
    'shiftRevenueReport.products.revenue': 'Doanh thu',
    'shiftRevenueReport.products.empty': 'Chưa bán sản phẩm nào trong ca.',
    'shiftRevenueReport.invoices.title': 'Danh sách hóa đơn',
    'shiftRevenueReport.accessibility.toggleShift': 'Mở hoặc đóng chi tiết ca {name}',
    'shiftRevenueReport.accessibility.toggleStaff': 'Mở hoặc đóng chi tiết nhân viên {name}',
  },
  en: {
    'shiftRevenueReport.title': 'Shift revenue',
    'shiftRevenueReport.filters.branch': 'Branch',
    'shiftRevenueReport.filters.shift': 'Work shift',
    'shiftRevenueReport.filters.staff': 'Staff',
    'shiftRevenueReport.filters.source': 'Sales source',
    'shiftRevenueReport.filters.all': 'All',
    'shiftRevenueReport.filters.unassigned': 'Unassigned shift',
    'shiftRevenueReport.filters.direct': 'Direct sale',
    'shiftRevenueReport.filters.table': 'Table sale',
    'shiftRevenueReport.actions.view': 'View report',
    'shiftRevenueReport.actions.export': 'Export Excel',
    'shiftRevenueReport.stats.revenue': 'Total revenue',
    'shiftRevenueReport.stats.invoices': 'Invoices',
    'shiftRevenueReport.stats.discount': 'Discount',
    'shiftRevenueReport.stats.vat': 'VAT',
    'shiftRevenueReport.stats.paid': 'Collected',
    'shiftRevenueReport.stats.debtPaid': 'Debt collected this shift',
    'shiftRevenueReport.debtPaid.invoice': 'Invoice',
    'shiftRevenueReport.debtPaid.customer': 'Customer',
    'shiftRevenueReport.debtPaid.receipt': 'Receipt',
    'shiftRevenueReport.debtPaid.amount': 'Collected',
    'shiftRevenueReport.stats.debt': 'Debt',
    'shiftRevenueReport.stats.formula.revenue':
      'Total revenue = Amount collected + Remaining debt of the shifts',
    'shiftRevenueReport.stats.formula.invoices': 'Invoice count = Completed invoices of the shifts',
    'shiftRevenueReport.stats.formula.discount': 'Discount = Total discount on the invoices',
    'shiftRevenueReport.stats.formula.vat': 'VAT = Total VAT on the invoices',
    'shiftRevenueReport.stats.formula.paid':
      'Collected = Invoice payments (excluding deposits) + Order/table deposits + Debt collected in shift',
    'shiftRevenueReport.stats.formula.debt':
      'Debt = Debt from the shifts - Debt collected in shift (not below 0)',
    'shiftRevenueReport.stats.formulaTitle': 'Calculation formula',
    'shiftRevenueReport.payments': 'Payment methods',
    'shiftRevenueReport.payments.cash': 'Cash',
    'shiftRevenueReport.payments.card': 'Card',
    'shiftRevenueReport.payments.bank_transfer': 'Bank transfer',
    'shiftRevenueReport.payments.transfer': 'Bank transfer',
    'shiftRevenueReport.payments.other': 'Other',
    'shiftRevenueReport.sources.direct': 'Direct sale',
    'shiftRevenueReport.sources.table': 'Table sale',
    'shiftRevenueReport.sources.table_session': 'Table sale',
    'shiftRevenueReport.customers.walkIn': 'Walk-in customer',
    'shiftRevenueReport.table.date': 'Shift date',
    'shiftRevenueReport.table.shift': 'Shift',
    'shiftRevenueReport.table.time': 'Time',
    'shiftRevenueReport.table.staff': 'Staff',
    'shiftRevenueReport.table.invoices': 'Invoices',
    'shiftRevenueReport.table.productQuantity': 'Product qty.',
    'shiftRevenueReport.table.revenue': 'Revenue',
    'shiftRevenueReport.table.paid': 'Collected',
    'shiftRevenueReport.table.debt': 'Debt',
    'shiftRevenueReport.table.invoiceCode': 'Invoice',
    'shiftRevenueReport.table.status': 'Status',
    'shiftRevenueReport.status.completed': 'Completed',
    'shiftRevenueReport.status.cancelled': 'Cancelled',
    'shiftRevenueReport.table.completedAt': 'Completed at',
    'shiftRevenueReport.table.source': 'Source',
    'shiftRevenueReport.table.customer': 'Customer',
    'shiftRevenueReport.table.payment': 'Payment',
    'shiftRevenueReport.empty': 'No revenue data',
    'shiftRevenueReport.emptyHint': 'Try another date range or filter.',
    'shiftRevenueReport.retry': 'Retry',
    'shiftRevenueReport.errors.loadFailed': 'Failed to load the shift revenue report.',
    'shiftRevenueReport.products.shiftTitle': 'All products sold during this shift',
    'shiftRevenueReport.products.staffTitle': 'Products sold by {name}',
    'shiftRevenueReport.products.sku': 'SKU',
    'shiftRevenueReport.products.name': 'Product',
    'shiftRevenueReport.products.unit': 'Unit',
    'shiftRevenueReport.products.quantity': 'Quantity',
    'shiftRevenueReport.products.revenue': 'Revenue',
    'shiftRevenueReport.products.empty': 'No products were sold during this shift.',
    'shiftRevenueReport.invoices.title': 'Invoice list',
    'shiftRevenueReport.accessibility.toggleShift': 'Toggle details for shift {name}',
    'shiftRevenueReport.accessibility.toggleStaff': 'Toggle details for staff member {name}',
  },
}
